<template>
  <div class="mid_career">
    <Hero
        :backImg="require('../assets/img/mid_career/hero.jpg')"
        :backImgSp="require('../assets/img/mid_career/hero_sp.jpg')"
        alt=""
        title="キャリア採用情報"
        text=""
    />
    <div class="contents">
      <dl class="looking">
        <dt>求める人物像</dt>
        <dd>
          <dl>
            <dd>
              <p>
                専門性の高い知識や<br />
                経験を持った方
              </p>
            </dd>
            <dd>
              <p>主体的に考え、自ら行動できる方</p>
            </dd>
            <dd>
              <p>
                社内外の関係者を巻き込んで<br />
                目標達成に邁進できる方
              </p>
            </dd>
            <dd>
              <p>
                新しいモノづくり、<br />
                仕組みづくりにチャレンジしたい方
              </p>
            </dd>
          </dl>
        </dd>
      </dl>
      <dl class="column01">
        <dt>募集職種</dt>

        <dd class="text-warning">{{"以下は2025年8月現在の情報です。\n時期によっては募集を終了している職種がございますことを、予めご了承のほどお願いいたします。"}}</dd>
        <dd>
          <dl>
            <dt>企画開発職系（総合職）</dt>
            <dd>
              <dl>
                <dt>勤務地 <br class="pc-only"/> <span style="color: black">東京都中央区</span></dt>
                <dd>
                  <p>・事業部門（本社）</p>
                  <p class="description desc-spec">〔包装材事業部（家庭用品の販売）〕</p>
                </dd>
              </dl>
              <dl>
                <dt></dt>
                <dd>
                  <p>・DXセンター（本社）</p>
                  <p class="description desc-spec">〔DX戦略の立案・推進、データ基盤の構築・運用・データ利活用、ネットワークインフラの構築・運用〕</p>
                </dd>
              </dl>
<!--              <dl>-->
<!--                <dt></dt>-->
<!--                <dd>-->
<!--                  <p>・経理財務部</p>-->
<!--                  <p class="description">〔決算（連結・単独）、税務対応、グループ会社への決算・税務支援〕</p>-->
<!--                </dd>-->
<!--              </dl>-->
<!--              <dl>-->
<!--                <dt></dt>-->
<!--                <dd>-->
<!--                  <p>・情報システム部</p>-->
<!--                  <p class="description">〔ロジスティクス、セキュリティに関わるシステムの企画・設計・開発・運用〕</p>-->
<!--                </dd>-->
<!--              </dl>-->
              <dl style="margin-top: 40px">
                <dt>勤務地 <br class="pc-only"/> <span style="color: black">東京都江東区</span></dt>
                <dd>
                  <p>
                    ・東京研究所
                  </p>
                  <p class="description">
                    〔新技術、新商品の研究開発〕
                  </p>
                </dd>
              </dl>
              <!-- <dl style="margin-top: 40px">
                <dt>勤務地 <br class="pc-only"/> <span style="color: black">茨城県小美玉市</span></dt>
                <dd>
                  <p>
                    ・樹脂加工研究所
                  </p>
                  <p class="description">
                    〔樹脂押出機械・ダイス設計〕
                  </p>
                </dd>
              </dl> -->
              <dl class="line"></dl>
              <dl>
                <dt>勤務地 <br class="pc-only"/> <span style="color: black">福島県いわき市</span></dt>
                <dd>
                  <p class="description-pr">
                    ※お問い合わせは労政部へお願いいたします。
                  </p>
                  <p style="margin-top: 16px">
                    ・企画・営業職（事務職）
                  </p>
                  <p class="description desc-spec-2">〔生産管理・事業企画、経理・財務、人事、情報システム 等〕</p>
                </dd>
              </dl>
              <dl>
                <dt></dt>
                <dd>
                  <p>
                    ・研究・技術職
                  </p>
                  <p class="description desc-spec" >〔研究開発、プロセス開発、プラントエンジニアリング、生産技術、品質管理、デジタル化推進、知的財産 等〕</p>
                </dd>
              </dl>
              <dl class="warning">
                <dd>
                  <p class="text-data">なお、勤務地は募集時点のもので、将来的に国内外の拠点に異動する場合があります。</p>
<!--                  <p>(2024年5月現在）</p>-->
                </dd>
              </dl>
            </dd>
            <div><a @click.stop="handleScrollTo(true)" class="cursor-pointer">お問い合わせはコチラ</a></div>
          </dl>
          <dl>
            <dt>実務推進職系（一般職）</dt>
            <dd>
              <dl>
                <dt class="inline-mb">
                  勤務地
                  <br />
                  <!--                  <br class="only-mb" />-->
                  <span>
                    <span>福島県いわき市</span><br/>
                  <span>茨城県小美玉市</span><br/>
                  </span>
                </dt>
                <dd>
                  <p>
                    ・製造職
                  </p>
                  <p class="description">〔化学・発電プラントにおける3交替勤務での各種設備の運転管理〕</p>
                  <p class="description">
                    〔生産工程の課題に対する改善・提案 等〕
                  </p>
                </dd>
              </dl>
              <dl style="margin-top: 0">
                <dt></dt>
                <dd>
                  <p class="desc-note description ">
                    ※製造職の勤務時間や休日・休暇等については、下記URLをご覧ください。
                  </p>

                  <p class="desc-link description ">
                    <a href="https://www.kureha-saiyou.com/recruit-info" target="_blank">
                     <span style="word-wrap: break-word; text-decoration: underline">
                       https://www.kureha-saiyou.com/recruit-info
                     </span>
                    </a>
                  </p>
                </dd>
              </dl>
              <dl>
                <dt></dt>
                <dd>
                  <p>
                    ・設備設計・管理職
                  </p>
                  <p class="description">
                    〔製造設備（電気、計装、機械等）の設計〕
                    <br/><span class="desc-ident">〔製造設備の保守・メンテナンス、保全計画の策定・管理〕</span>
                  </p>
                </dd>
              </dl>
              <dl>
                <dt></dt>
                <dd>
                  <p>
                    ・分析評価職
                  </p>
                  <p class="description">
                    〔各種製品や開発品に関する分析・評価〕
                  </p>
                </dd>
              </dl>
              <dl class="warning">
                <dd>
                  <p class="text-data">
                    なお、当面の勤務地は募集している事業所となりますが、<br class="pc-only" />
                    将来的に国内外の拠点に異動する可能性があります。</p>
<!--                  <p>(2024年5月現在）</p>-->
                </dd>
              </dl>
            </dd>
            <div><a @click.stop="handleScrollTo()" class="cursor-pointer">お問い合わせはコチラ</a></div>
          </dl>
        </dd>
      </dl>
      <dl class="column02">
        <dt>待遇と勤務</dt>
        <dd>
          <dl>
            <dt>契約期間</dt>
            <dd class="center-line">
              <p>期間の定めなし</p>
            </dd>
            <dt>試用期間</dt>
            <dd class="center-line">
              <p>試用期間有り（3ヶ月）</p>
            </dd>
            <dt>給与</dt>
            <dd>
              <p>企画開発職系（総合職）：月給　26万円以上</p>
              <p class="supplement">
                経験、能力などを考慮し、当社規定により支給いたします。
              </p>
              <br />
              <p>実務推進職系（一般職）：月給　20万円以上</p>
              <p class="supplement">
                経験、能力などを考慮し、当社規定により支給いたします。
              </p>
            </dd>
            <dt>賞与</dt>
            <dd class="center-line">
              <p>年2回（6月、12月）</p>
            </dd>
            <dt>勤務時間</dt>
            <dd>
              <p>
                ・ 本社、営業所、研究所（小美玉市、江東区）<br class="mb-only" />9:00～17:30
              </p>
              <p>・ 事業所（いわき市）、研究所（いわき市）<span class="ml"> <br class="mb-only">8:30～17:00</span></p>
              <p>・ 事業所（小美玉市、丹波市）<span class="ml ml-time-spec"> <br class="mb-only">9:00〜17:30</span></p>
              <p class="supplement">※一部フレックスタイム制あり</p>
            </dd>
            <dt>休憩時間</dt>
            <dd class="center-line">
              <p>45分</p>
            </dd>
            <dt>時間外労働</dt>
            <dd class="center-line">
              <p>有り</p>
            </dd>
            <dt>休日・休暇・休業</dt>
            <dd>
              <p>
                ・ 完全週休2日制、祝日、年末年始等、年間休日数124日（2025年）
              </p>
              <p>
                ・ 年次有給休暇 （初年度 入社日により1～15日、2年目16日、以降1年ごとに1日ずつ加算し、最高は20日）
              </p>
              <span class="supplement" style="display: block; margin: -4px 0">※半日単位または１時間単位での取得も可能</span>
              <p>
                ・
                転勤休暇、慶弔休暇、生理休暇、育児休業、介護休業 など
              </p>
            </dd>
            <dt>保険</dt>
            <dd class="center-line"><p>雇用保険、労災保険、健康保険、厚生年金保険</p></dd>
            <dt>諸手当</dt>
            <dd class="center-line"><p>育児手当、介護手当、自家手当、通勤費 など</p></dd>
            <dt>福利厚生制度</dt>
            <dd>
              共済会、各種財形制度、積立年金、貸付金、持株会、援護会、見舞金、社宅・寮、家賃補助、カフェテリアプラン など
            </dd>
            <dt>その他</dt>
            <dd>
              <p>・本社・営業所地区のみ在宅勤務制度あり（8回/月を上限）</p>
              <p>・定年年齢 65歳（段階的に引き上げ）</p>
            </dd>
          </dl>
        </dd>
      </dl>
      <dl class="column03" id="contact">
        <dt>お問い合わせ先</dt>
        <dd>
          <dl>
            <dt>企画開発職系（総合職）</dt>
            <dd>
              <p>
                企画開発職系（総合職）の募集職種にご関心のある方は、下記の転職エージェントにご相談ください。
              </p>
              <a href="https://www.jac-recruitment.jp/entry/" target="_blank">
                 <span>
                   株式会社ジェイ エイ シー リクルートメント
                 </span>
                <IconBase :width="12" iconColor="#000000" class="icon_base"
                ><Blank
                /></IconBase>
              </a>
              <a href="https://www.pasonacareer.jp/" target="_blank">
                 <span>
                   株式会社パソナ
                 </span>
                <IconBase :width="12" iconColor="#000000" class="icon_base"
                ><Blank
                /></IconBase>
              </a>
              <a href="https://doda.jp/" target="_blank">
                 <span>
                   パーソルキャリア株式会社
                 </span>
                <IconBase :width="12" iconColor="#000000" class="icon_base"
                ><Blank
                /></IconBase>
              </a>
              <a href="https://www.r-agent.com/" target="_blank">
                 <span>
                   株式会社リクルート
                 </span>
                <IconBase :width="12" iconColor="#000000" class="icon_base"
                ><Blank
                /></IconBase>
              </a>
              <span class="supplement-bold">
                ※福島県いわき市勤務の職種にご関心のある方は、<br>
                労政部までご連絡ください。
              </span>
<!--              <a href="https://www.jmsc.co.jp/" target="_blank">-->
<!--                 <span>-->
<!--                  株式会社MS-Japan-->
<!--                 </span>-->
<!--                <IconBase :width="12" iconColor="#000000" class="icon_base"-->
<!--                ><Blank-->
<!--                /></IconBase>-->
<!--              </a>-->
            </dd>
          </dl>
          <dl id="contact-2">
            <dt>
              実務推進職系（一般職）
            </dt>
            <dd>
              <p >
                実務推進職系（一般職）の募集職種にご関心のある方は、下記までご連絡ください。
              </p>
              <p class="normal">〒974-8686福島県いわき市錦町落合16</p>
              <p class="normal">労政部　採用担当</p>
              <a class="link" href="tel:0246-63-4457">
                TEL　0246-63-4457（労政部直通）
              </a>
              <a href="mailto:saiyou-kri@kureha.co.jp">
                MAIL　saiyou-kri@kureha.co.jp
              </a>
            </dd>
          </dl>
        </dd>
      </dl>
      <dl class="recruitment-ratio">
        <dt>中途採用（キャリア採用）比率</dt>
        <dd>労働施策総合推進法に基づく中途採用比率の公表</dd>
        <dd class="table-wrap">
          <table class="pc-table">
            <tr>
              <th></th>
              <th>2022年度</th>
              <th>2023年度</th>
              <th>2024年度</th>
            </tr>
            <tr>
              <td>正規雇用労働者の<br />中途採用比率</td>
              <td>30%</td>
              <td>44%</td>
              <td>34%</td>
            </tr>
          </table>
          <table class="sp-table">
            <tr>
              <th></th>
              <th>正規雇用労働者の中途採用比率</th>
            </tr>
            <tr>
              <th>2022年度</th>
              <td>30%</td>
            </tr>
            <tr>
              <th>2023年度</th>
              <td>44%</td>
            </tr>
            <tr>
              <th>2024年度</th>
              <td>34%</td>
            </tr>
          </table>
          <p class="supplement">公表日：2025年5月1日</p>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
import IconBase from "@/components/IconBase.vue";
import Blank from "@/components/icons/Blank.vue";
export default {
  components: {
    Blank, IconBase,
    Hero,
  },
  methods: {
    converter: function (M) {
      var str = '',
          str_as = '';
      for (var i = 0; i < M.length; i++) {
        str_as = M.charCodeAt(i);
        str += String.fromCharCode(str_as + 1);
      }
      return str;
    },
    mail_to(k_1, k_2) {
      eval(
          String.fromCharCode(
              108,
              111,
              99,
              97,
              116,
              105,
              111,
              110,
              46,
              104,
              114,
              101,
              102,
              32,
              61,
              32,
              39,
              109,
              97,
              105,
              108,
              116,
              111,
              58
          ) +
          escape(k_1) +
          this.converter(
              String.fromCharCode(
                  113,
                  100,
                  98,
                  113,
                  116,
                  104,
                  115,
                  63,
                  106,
                  116,
                  113,
                  100,
                  103,
                  96,
                  45,
                  98,
                  110,
                  45,
                  105,
                  111,
                  62,
                  114,
                  116,
                  97,
                  105,
                  100,
                  98,
                  115,
                  60
              )
          ) +
          escape(k_2) +
          "'"
      );
    },
    mail_to_iwaki(k_1, k_2) {
      eval(
          String.fromCharCode(
              108,
              111,
              99,
              97,
              116,
              105,
              111,
              110,
              46,
              104,
              114,
              101,
              102,
              32,
              61,
              32,
              39,
              109,
              97,
              105,
              108,
              116,
              111,
              58
          ) +
          escape(k_1) +
          this.converter(
              String.fromCharCode(
                  114,
                  96,
                  104,
                  120,
                  110,
                  116,
                  44,
                  106,
                  113,
                  104,
                  63,
                  106,
                  116,
                  113,
                  100,
                  103,
                  96,
                  45,
                  98,
                  110,
                  45,
                  105,
                  111,
                  62,
                  114,
                  116,
                  97,
                  105,
                  100,
                  98,
                  115,
                  60
              )
          ) +
          escape(k_2) +
          "'"
      );
    },
    handleScrollTo(isFirstContact) {
      let element;
      if(window.innerWidth < 767){
         element = isFirstContact ? document.querySelector('#contact') : document.querySelector('#contact-2')
      }else{
        element = document.querySelector('#contact')
      }

      window.scrollTo({
        top: window.innerWidth < 767 ?  element.offsetTop - (isFirstContact ? -240 : 20) : element.offsetTop + 80,
        behavior: 'smooth'
      })
    }
  },
};
</script>

<style lang="scss" scoped>
@media print, screen and (max-width: 767px) {
  .pc-only {
    display: none;
  }
}
.contents {
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding: 100px 0 150px;
  @media print, screen and (max-width: 767px) {
    padding: 50px 0 100px 0;
  }
}
dl,
dt,
dd {
  margin: 0;
  padding: 0;
}
.column01 {
  max-width:  800px;
  margin: 0 auto;
  font-weight: bold;
  & > dt {
    font-size: 30px;
    text-align: center;
    @media print, screen and (max-width: 767px) {
      font-size: 20px;
    }
  }
  & > dt:nth-child(n + 2) {
    @media print, screen and (max-width: 767px) {
      margin-top: 70px;
      padding-top: 50px;
    }
  }
  & > dd {
    & > dl {
      position: relative;
      border: 2px solid var(--darkBlue);
      border-radius: 5px;
      margin-top: 16px;
      &:nth-child(n + 2) {
        margin-top: 100px;
        @media print, screen and (max-width: 767px) {
          margin-top: 80px;
        }
      }
      & > dt {
        background-color: var(--darkBlue);
        color: #fff;
        text-align: center;
        font-size: 22px;
      }
      & > dd {
        font-size: 16px;
        padding: 30px 60px 40px 60px;
        @media print, screen and (max-width: 767px) {
          padding: 30px 40px 40px 40px;
        }

        & > dl {
          & + dl {
            margin-top: 16px;
            &:is(.line){
              height: 1px;
              background-color: var(--darkBlue);
              width: 100%;
              margin: 36px 0;
            }

            &:is(.warning){
              margin: 50px auto 44px auto;
              display: flex;

              align-items: center;
              justify-content: center;
              & > dd {
                max-width: fit-content;
                @media print, screen and (max-width: 767px) { max-width: 100%; }
                & > p{
                  text-align: right;
                  font-size: 15px;
                  line-height: 200%;
                  &:is(.text-data){
                    text-align: center;

                    @media print, screen and (max-width: 767px) {
                      text-align: left;
                    }
                  }
                  @media print, screen and (max-width: 767px) {
                    text-align: left;
                    //&:last-child{
                    //  text-align: right;
                    //}

                  }
                }
              }
            }
          }
          line-height: 1.5em;
          @media print, screen and (min-width: 768px) {
            display: flex;
          }
          & > dt {
            color: var(--darkBlue);
            max-width: 10em;
            width: 100%;
            @media print, screen and (max-width: 767px) { max-width: 15em; margin-bottom: 16px; }
            & > span{
              color: black;
            }
          }
          & > dd {
            max-width: calc(100% - 10em);
            width: 100%;
            @media print, screen and (max-width: 767px) {
              max-width: 100%;
            }
            & > p {
              line-height: 1.5em;
              margin: 0;
              text-indent: -0.3em;

              &:is(.text-data){
                text-indent: 0;
              }

              &:is(.description){
                font-weight: 500;
                font-size: 13px;
                text-indent: 0.4em;
                @media print, screen and (max-width: 767px) {
                  font-size: 15px;
                  text-indent: -0.4em;
                  padding-left: 10px;
                }
              }

              &:is(.description-pr){
                color: var(--darkBlue);
              }
            }
          }
        }
        & > dl:first-child {
          & > dd {
            & > p {
              text-indent: -0.3em;
              //margin-left: 1.3em;

              &:is(.description){
                text-indent: 0.4em;
                font-weight: 500;

                @media print, screen and (max-width: 767px) { text-indent: -0.4em;}

              }
            }
          }
        }
      }
      & > div {
        height: 36px;
        position: absolute;
        left: 50%;
        bottom: -21px;
        transform: translateX(-50%);
        border: 2px solid var(--darkBlue);
        border-radius: 22px;
        background-color: #fff;
        padding: 0 3em 0 1.8em;
        display: flex;
        align-items: center;
        & > a {
          color:  var(--darkBlue);
          display: inline-block;
          margin: 0;
          position: relative;
          white-space: nowrap;
          &::before {
            content: '';
            position: absolute;
            top: 11px;
            right: -1.2em;
            width: 6px;
            height: 6px;
            border-bottom: 2px solid var(--darkBlue);
            border-right: 2px solid var(--darkBlue);
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
          }
        }
      }
    }
  }
  .under-text {
    @media print, screen and (min-width: 598px) {
      display: none;
    }
  }
}
.column02 {
  margin-top: 165px;
  font-weight: bold;
  @media print, screen and (max-width: 767px) { margin-top: 100px; }
  & > dt {
    font-size: 30px;
    text-align: center;
    @media print, screen and (max-width: 767px) {
      font-size: 20px;
    }
  }
  & > dd {
    font-size: 16px;
    margin-top: 30px;
    & > dl {
      display: flex;
      flex-wrap: wrap;
      margin: 0;
      border-top: 2px solid var(--darkBlue);
      @media print, screen and (max-width: 767px) {
        flex-direction: column;
      }
      & > dt {
        padding: 20px 0 0 0;
        display: flex;
        align-items: center;
        font-size: 18px;
        @media print, screen and (min-width: 768px) {
          width: 260px;
          justify-content: center;
          border-bottom: 2px solid var(--darkBlue);
          padding: 30px 0;
        }
      }
      & > dd {
        padding: 0 0 20px 0;
        margin: 0;
        border-bottom: 2px solid var(--darkBlue);
        @media print, screen and (min-width: 768px) {
          width: calc(100% - 260px);
          padding: 30px 0;
        }
        & > p {
          line-height: 1.5em;
          margin: 0;
          text-indent: -1.3em;
          margin-left: 1.3em;
        }
        .supplement {
          font-size: 13px;
          font-weight: normal;
          margin: 0;
          margin-left: 0;
          text-indent: 0;
        }
        a {
          color: #fff;
          display: inline-block;
          & + a {
            margin-left: 10px;
            margin-top: 10px;
            @media print, screen and (max-width: 597px) {
              margin-left: 0;
            }
          }
          i {
            margin-right: 1px;
          }
          i:first-child {
            border-radius: 20px 0 0 20px;
            padding: 10px 10px 10px 20px;
          }
          i:nth-child(2) {
            border-radius: 0 20px 20px 0;
            padding: 10px 20px 10px 10px;
          }
        }
        a.tel i {
          background-color: var(--darkBlue);
          font-weight: normal;
        }
        a.mail i {
          background-color: #007a7f;
          font-weight: normal;
        }
      }
    }
    #contact {
      margin-top: -100px;
      padding-top: 120px;
      @media print, screen and (max-width: 767px) {
        margin-top: -80px;
        padding-top: 100px;
      }
      + dd {
        > dl {
          &:nth-child(n + 2) {
            margin-top: 40px;
          }
          &:nth-last-child(n + 2) {
            display: flex;
            flex-wrap: wrap;
            > dt {
              font-size: 18px;
              margin-right: 50px;
              @media print, screen and (max-width: 767px) {
                margin-right: 20px;
              }
            }
            > dd {
              @media print, screen and (min-width: 400px) {
                //段落ち揃えるため
                width: 310px;
              }
            }
            @media print, screen and (max-width: 767px) {
              margin-top: 20px !important;
            }
          }
        }
      }
    }
  }
}
.recruitment-ratio {
  margin-top: 100px;
  & > dt {
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    @media print, screen and (max-width: 767px) {
      font-size: 20px;
    }
  }
  td,
  th {
    border: 2px solid #3fac00;
    color: #3fac00;
    text-align: center;
    font-weight: bold;
  }
  & > dd {
    margin: 35px 0 20px 0;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    @media print, screen and (max-width: 767px) {
      font-size: 16px;
    }
    &.table-wrap {
      width: 100%;
      max-width: 800px;
      margin: 0 auto;
      > table {
        width: 100%;
        @media print, screen and (min-width: 768px) {
          &.sp-table {
            display: none;
          }
        }
        @media print, screen and (max-width: 767px) {
          &.pc-table {
            display: none;
          }
        }
        > tr {
          > td {
            padding: 15px 0;
            width: 20%;
            font-size: 26px;
            &:first-child {
              font-size: 16px;
              line-height: 1.5em;
            }
            @media print, screen and (max-width: 767px) {
              padding: 5px 0;
              width: 70%;
            }
          }
          > th {
            padding: 5px 0;
          }
        }
      }
    }
  }
  .supplement {
    font-size: 13px;
    font-weight: normal;
    margin: 0;
    margin-left: 0;
    text-indent: 0;
    text-align: right;
  }
}
.indent {
  @media print, screen and (min-width: 768px) {
    text-indent: -1.3em;
    display: inline-block;
    margin: 0;
    margin-left: 1.3em;
  }
}

.looking{
  transition: max-width linear .8s;
  max-width: 800px;
  margin: 0 auto;
  @media print, screen and (max-width: 597px) {
    width: 100%;
  }
  & > dt{
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    color: black;
    @media print, screen and (max-width: 767px) {
      font-size: 22px;
    }
  }

  & > dd{
    width: 100%;
    margin: 42px auto 160px auto;
    @media print, screen and (max-width: 767px) {
      margin-bottom: 100px;
    }
    & > dl {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 32px;
      row-gap: 24px;
      box-sizing: border-box;
      @media print, screen and (max-width: 767px) {
        grid-template-columns: 100%;
        row-gap: 20px;
      }
      & > dd{
        padding: 0 32px;
        border-radius: 4px;
        background-color: var(--darkBlue);
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 120px;
        & > p {
          text-align: center;
          color: white;
          font-weight: 700;
          font-size: 20px;
          line-height: normal;
          @media print, screen and (max-width: 767px) {
            font-size: 17px;
          }
        }
      }
    }
  }
}

.column03{
  padding-top: 176px;
  @media print, screen and (max-width: 767px) { margin-top: 100px; }
  & > dt{
    font-size: 30px;
    font-weight: 700;
    color: black;
    text-align: center;
    margin-bottom: 46px;
    @media print, screen and (max-width: 767px) { font-size: 20px; }
  }
  & > dd{
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-radius: 5px;
    border: 2px solid var(--darkBlue);
    @media print, screen and (max-width: 767px) {
      grid-template-columns: 1fr;
      border: none;
      row-gap: 24px;
    }
    & > dl {
      &:last-child{
        border-left: 2px solid var(--darkBlue);
        & > dt{
          &:before{
            content: '';
            position: absolute;
            top: -2px;
            bottom: 0;
            left: -2px;
            width: 2px;
            background-color: white;
            @media print, screen and (max-width: 767px) { display: none; }
          }
        }
      }
      @media print, screen and (max-width: 767px) {
        border: 2px solid var(--darkBlue);
        border-radius: 4px;
      }
      & > dt {
        background-color: var(--darkBlue);
        font-size: 22px;
        font-weight: 700;
        color: white;
        text-align: center;
        position: relative;
        @media print, screen and (max-width: 767px) { font-size: 18px }
        //&:before{
        //  content: '';
        //  position: absolute;
        //  top: 0;
        //  bottom: 0;
        //  left: -2px;
        //  width: 2px;
        //  background-color: white;
        //  @media print, screen and (max-width: 767px) { display: none; }
        //}
      }
      & > dd{
        padding: 32px;
        @media print, screen and (max-width: 767px) { padding: 30px 40px 40px 40px; }
        & > p{
          font-size: 18px;
          font-weight: 700;
          color: black;
          margin: 0 0 40px 0;
          @media print, screen and (max-width: 767px) { font-size: 16px; margin: 0 0 36px 0; }
          &:is(.normal){
            margin: 0;
          }
        }
        & > a {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          column-gap: 10px;
          margin: 14px 0;

          &:not(:has(span)){
            font-size: 18px;
            font-weight: 700;
            color: black;
            margin: 0;
            @media print, screen and (max-width: 767px) { font-size: 16px; }
          }
          & > span {
            font-size: 18px;
            font-weight: 700;
            color: black;
            border-bottom: 1px solid var(--darkBlue);
            line-height: normal;
            @media print, screen and (max-width: 767px) { font-size: 16px; }
          }
          & > svg{
            @media print, screen and (max-width: 767px) { width: 16px }
          }
        }
      }
    }
  }
}

.link{
  cursor: pointer;
  &:hover{
    opacity: 0.5;
  }
}

.center-line {
  display: flex;
  align-items: center;
}

.ml{
  margin-left: 24px;
  @media print, screen and (max-width: 767px) { margin-left: 0; }
}

.mt-pc{
  margin-top: -12px;
}

.only-mb{
  display: none;
  @media print, screen and (max-width: 767px) { display: block; }
}

.inline-mb{
  @media print, screen and (max-width: 767px) { display: flex; gap: 12px }
}

.cursor-pointer{
  cursor: pointer;
}
.mb-only{
  display: none;
  @media print, screen and (max-width: 767px) { display: block }
}

.desc-ident{
  margin-left: 5px;
  @media print, screen and (max-width: 767px) { margin: 0; display: block; }
}

.desc-spec{
  text-indent: -0.4em !important;
  padding-left: 0.8em;
  @media print, screen and (max-width: 767px) { padding: 0 }
}

.desc-spec-2{
  @media print, screen and (max-width: 767px) {  text-indent: -0.4em !important; }
}

.desc-link{
  text-indent: 0.9em !important;
  @media print, screen and (max-width: 767px) {
    text-indent: 0 !important;
  }
}

.desc-note{
  text-indent: 0.9em !important;
  @media print, screen and (max-width: 767px) {
   text-indent: 0.1em !important;
  }
}

.text-data{
  line-height: 200%;
  text-align: center;
  text-indent: 0;
  @media print, screen and (max-width: 767px) {
    text-align: left;
  }
}

.text-warning{
  font-size: 13px;
  font-weight: 500;
  white-space: pre-wrap;
  margin-top: 60px;
  line-height: normal;

  @media print, screen and (max-width: 767px) {
    margin-top: 42px;
    font-size: 15px;
  }
}

.ml-time-spec{
margin-left: 112px;
  @media print, screen and (max-width: 767px) {
    margin-left: 0;
  }
}

.supplement-bold{
  display: block;
  font-size: 13px;
  line-height: 1.5;
  font-weight: bold;
}
</style>
